import React from 'react';
import PropTypes from 'prop-types';

import { Menu, MenuItem, makeStyles } from '@material-ui/core';
import { openSnackbar } from '../../redux/ui/Actions';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => style(theme));

const propTypes = {
    contextMenu: PropTypes.shape({
        mouseY: PropTypes.number.isRequired,
        mouseX: PropTypes.number.isRequired,
        lngLat: PropTypes.shape({
            lat: PropTypes.number.isRequired,
            lng: PropTypes.number.isRequired
        })
    }),
    onClose: PropTypes.func.isRequired
};

const defaultProps = {
    contextMenu: null
};

function MapContextMenu ({ contextMenu, onClose }) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const lngLatText = contextMenu && `${contextMenu.lngLat.lng.toFixed(6)}, ${contextMenu.lngLat.lat.toFixed(6)}`;
    const latLngText = contextMenu && `${contextMenu.lngLat.lat.toFixed(6)},${contextMenu.lngLat.lng.toFixed(6)}`;

    function copyToClipboard() {
        navigator.clipboard.writeText(lngLatText);
        dispatch(openSnackbar('success', 'Copied to clipboard'));
    }

    return (
        <Menu
            classes={{ list: classes.menuList }}
            open={Boolean(contextMenu)}
            onClose={onClose}
            onContextMenu={onClose}
            anchorReference="anchorPosition"
            anchorPosition={
                contextMenu
                    ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                    : undefined
            }
        >
            <MenuItem
                classes={{ root: classes.menuItemRoot }}
                onClick={copyToClipboard}
            >
                {Boolean(contextMenu) && lngLatText}
            </MenuItem>
            <MenuItem
                classes={{ root: classes.menuItemRoot }}
                href={`http://maps.google.com?q=${latLngText}`}
                target="_blank"
                component="a" 
            >
                View on Google Maps
            </MenuItem>
            <MenuItem
                classes={{ root: classes.menuItemRoot }}
                href={`http://maps.google.com?q=&layer=c&cbll=${latLngText}`}
                target="_blank"
                component="a" 
            >
                View in Google Street View
            </MenuItem>
        </Menu>
    );
}

const style = theme => ({
    menuList: {
        // paddingTop: 2,
        // paddingBottom: 2
    },
    menuItemRoot: {
        // paddingLeft: 8,
        // paddingRight: 8,
        // paddingTop: 2,
        // paddingBottom: 2,
        // fontSize: 12
    }
});

MapContextMenu.propTypes = propTypes;
MapContextMenu.defaultProps = defaultProps;

export default MapContextMenu;